/**
 * RDT rule types (regulation options) from the Driving Times Service (DTS).
 *
 * @readonly
 * @enum {string}
 */
export const RdtRuleTypes = Object.freeze({
    BUS_RULE: 'BUS_RULE',
    WORKING_TIME_RULES: 'WORKING_TIME_RULES',
    EMPLOYMENT_TYPE: 'EMPLOYMENT_TYPE'
})
